import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useGlobalPagination = create(
  persist(
    (set) => ({
      limit: 5,
      lastKeys: {},
      search: "",
      page: 1,
      total: 0,
      skip: 0,
      pathname: "",

      setLastKey: (page, lastKey) =>
        set((state) => ({
          lastKeys: { ...state.lastKeys, [page]: lastKey },
        })),

      setLimit: (limit) => set({ limit, page: 1, lastKeys: {} }),
      setSearch: (search) => set({ search, page: 1, lastKeys: {} }),
      setPage: (page) => set({ page }),
      setTotal: (total) => set({ total }),
      setPathName: (pathname) => set({ pathname }),
      setSkip : (skip) => set({ skip }),

      reset: () =>
        set({ limit: 5, lastKeys: {}, search: "", page: 1, skip: 0 }),

      restoreState: (state) => set(state),
    }),
    {
      name: "pagination-storage", // storage का नाम (localStorage key)
      getStorage: () => localStorage, // या sessionStorage भी use कर सकते हो
    },
  ),
);
